import { render, staticRenderFns } from "./CertificateTreatmentMobile.vue?vue&type=template&id=04f2f927&scoped=true&"
import script from "./CertificateTreatmentMobile.vue?vue&type=script&lang=ts&"
export * from "./CertificateTreatmentMobile.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateTreatmentMobile.vue?vue&type=style&index=0&id=04f2f927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2f927",
  null
  
)

export default component.exports